export default function StatCard({ label, value, accent }) {
  return (
    <div className="card">
      <p className="text-xs uppercase tracking-wider text-lumora-text/50">{label}</p>
      <p className={`text-2xl font-serif font-medium mt-2 ${accent ? 'text-lumora-wood' : 'text-lumora-dark-wood'}`}>
        {value}
      </p>
    </div>
  );
}
